import axios from 'axios';
import Vue from 'vue';
import GrooveUIKitV2 from '../../groove-ui-kit-v2/src/vue2/groove-ui-kit';
import GsNamedModal from '../../groove-ui-kit-v2/src/vue2/named-modal-adapter';
import '../../groove-ui-kit-v2/src/styles/groove-ui-kit.css';
import '../../groove-ui-kit-v2/src/styles/refresh-controls.css';
import './assets/sass/new_ui/_gm-refresh-tables.scss';

Vue.use(GrooveUIKitV2);
Vue.component('gs-named-modal', GsNamedModal);
import CKEditor from '@ckeditor/ckeditor5-vue';
import vueCustomElement from 'vue-custom-element';
import VuePapaParse from 'vue-papa-parse';
import * as shadow from 'vue-shadow-dom';
import VueHtml2Canvas from 'vue-html2canvas';
import App from './components/App.vue';
import store from './state';
import router from './router';
import wait from './plugins/wait';
import './components';
import './plugins';
import '@groovepages/gd-ui-kit/styles.css';
import config from '../../load-config';
import i18n from './plugins/i18n';
import 'document-register-element/build/document-register-element';
// import Widget from './Widget.vue';
import Widget from './pages/forms/view.vue';
import { iframeResize } from "iframe-resizer";

Vue.use(VueHtml2Canvas);

Vue.use(VuePapaParse);
Vue.use(VueHtml2Canvas);
Vue.use(CKEditor);
Vue.directive('iframeResize', {
  bind: function(el, { value = {} }) {
    el.addEventListener('load', () => iframeResize(value, el))
  },
  unbind: function (el) {
    if (el.iFrameResizer) {
      el.iFrameResizer.removeListeners();
    }
  }
});

config.then(configValues => {
  axios.defaults.baseURL = `${configValues.VUE_APP_API_URL}/groovemail`;

  let user = JSON.parse('{}');

  try {
    if ('localStorage' in window && window.localStorage) {
      user = JSON.parse(window.localStorage.getItem('user') || '{}');
    }
  } catch (exception) {}

  if (!user.auth_keycloak) {
    axios.defaults.headers.common = {
      ...axios.defaults.headers.common,
      'x-auth-provider': 'auth0'
    };
  }

  let appFrontendURL = configValues.VUE_APP_FRONTEND_URL;

  if (configValues.VUE_APP_FRONTEND_URL.includes('/groovepages')) {
    appFrontendURL = configValues.VUE_APP_FRONTEND_URL.replace(
      '/groovepages',
      ''
    );
  }
  const localConfig = {
    apiUrl: `${configValues.VUE_APP_API_URL}/groovemail`,
    appUrl: `${configValues.VUE_APP_GROOVESELL_URL}`,
    grooveappsurl: appFrontendURL,
    apiCoreUrl: `${configValues.VUE_APP_API_URL}`
  };
  window.config = localConfig;
  window.gdEnv = Object.keys(configValues).reduce((acc, key) => {
    acc[key] = process.env[key] || configValues[key];
    return acc;
  }, {});

  Vue.config.productionTip = false;
  Vue.use(vueCustomElement);
  Vue.customElement('groovemail-form-embed', Widget);

  Vue.use(shadow);

  /* eslint-disable no-new */
  store.dispatch('initCore').then(() => {
    new Vue({
      el: '#app',
      i18n,
      store,
      router,
      wait,
      ...App
    });
  });
});
